<script lang="ts" setup>
import Menu from '@/components/Menu.vue';
import Logo from '@/components/Logo.vue';
import Footer from '@/components/Footer.vue';
import Version from '@/components/Version.vue';
import Modal from '@/components/common/Modal.vue';
import Drawer from '@/components/common/Drawer.vue';
import Notifications from '@/components/common/Notifications.vue';
</script>
<template>
  <div>
    <header>
      <Logo></Logo>
      <Menu></Menu>
    </header>
    <main>
      <RouterView />
    </main>
    <footer>
      <Footer></Footer>
      <Version />
    </footer>
    <Drawer></Drawer>
    <Modal></Modal>
    <Notifications />
  </div>
</template>
<style src="@/css/docs.less" lang="less"></style>
